import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

export default async function markPatientJoined(timeslotId: string | number) {
  const res = await fetchOrchidAPI(
    `/api/scheduler/v1/timeslot_orchid_pro/mark_patient_joined?timeslot_id=${timeslotId}`,
    {
      method: "POST",
    },
  );

  if (!res.ok) {
    throw new Error(
      `failed to mark patient joined: ${getErrorDetail(await res.text())}`,
    );
  }

  return;
}
